import { carouselStyles } from "@insite/content-library/Components/Carousel";
import { productCarouselProductCondensedStyles } from "@insite/content-library/Components/ProductCarouselProductCondensed";
import { productCarouselProductFullStyles } from "@insite/content-library/Components/ProductCarouselProductFull";
import { carouselStyles as productCarouselStyles } from "@insite/content-library/Components/ProductCompareCarousel";
import { productCompareFlyOutStyles } from "@insite/content-library/Components/ProductCompareFlyOut";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

carouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 5px;
        background: #f8f8f8;
        z-index: 1;
        &:hover {
            background: ${getColor("primary")};
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};
carouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 5px;
        background: #f8f8f8;
        z-index: 1;
        &:hover {
            background: ${getColor("primary")};
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};
productCarouselProductCondensedStyles.productDetailsGridItem = {
    width: 7,
    css: css`
        flex-direction: column;
        > div > div {
            padding: 5px 0px;
        }
    `,
};
productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        // [data-test-selector="slides"] {
        //     > div {
        //         width: auto !important;
        //     }
        // }
        & [data-test-selector="slideContainer"] {
            padding: 0 10px;
            [class^="GridWrapper"] {
                [class^="GridOffset"] {
                    border: 1px solid #e1e1e1;
                    margin: 0;
                    display: block;
                    a {
                        width: 60px;
                        height: 60px;
                    }
                }
                [class^="GridItemStyle"] {
                    flex-basis: 100%;
                    max-width: 100%;
                    padding: 10px;
                    &:nth-of-type(2) {
                        display: none;
                    }

                    &:last-of-type {
                        position: absolute;
                        top: -4px;
                        right: 6px;
                        padding: 0;

                        button {
                            padding: 0;
                            background: transparent;
                            height: auto;
                            border: 0;

                            &:hover {
                                border: 0;
                                [class^="IconWrapper"] {
                                    color: #ef3742;
                                }
                            }

                            [class^="IconWrapper"] {
                                top: 0;
                                width: 15px;
                            }
                        }
                    }
                }
            }
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                ],
                "max",
            )}
    `,
};
productCompareFlyOutStyles.headerTitleGridItem = {
    width: [12, 6, 6, 6, 6],
    align: "middle",
    css: css`
        > h5 {
            padding: 05px 15px;
        }
    `,
};

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    size: 200,
    cssOverrides: {
        scrim: css`
            width: 50%;
            transform: translateX(-50%);
            left: 50%;
            border: 1px solid #efefef;
            height: 180px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100% !important;
                            border-left: 0;
                            border-right: 0;
                            height: 180px;
                        `,
                        null,
                        null,
                        css`
                            width: 70%;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerBody: css`
            height: 180px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 180px;
                        `,
                    ],
                    "max",
                )}
        `,
        drawerTitle: css`
            background: #f8f9fa;
            color: #363636;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCarouselStyles.carouselContentEmptyCellGridItem = {
    width: [0, 0, 0, 2, 2],
};
productCarouselStyles.attributeValueGridItem = {
    css: css`
        overflow: visible;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        overflow-wrap: break-word;
        word-break: break-word;
        flex-basis: 100%;
        max-width: 100%;
        border-bottom: 1px solid rgb(204, 204, 204);
        padding: 0.8rem;
        padding-left: 30px;
        &:nth-child(2n) {
            background-color: rgb(248, 249, 250);
        }
    `,
};

productCarouselStyles.carouselCellGridItem = {
    width: [12, 12, 12, 10, 10],
};

productCarouselStyles.carouselSlidesContainer = {
    css: css`
        display: flex;
        > div {
            overflow: hidden;
            padding: 0 20px;

            > div {
                padding: 0;
                position: relative;
                border: 1px solid rgb(227, 227, 227);
            }
        }
    `,
};
productCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 5px;
        background: #f8f8f8;
        z-index: 1;
        &:hover {
            background: ${getColor("primary")};
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};
productCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 5px;
        background: #f8f8f8;
        z-index: 1;
        &:hover {
            background: ${getColor("primary")};
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};
productCarouselStyles.attributeLabelsGridContainer = {
    gap: 0,
    css: css`
        box-shadow: 0 0 black;
        z-index: 1;
    `,
};
productCarouselStyles.attributeLabelGridItem = {
    width: 12,
    css: css`
        > span {
            font-weight: bold;
        }
        border-bottom: ${({ theme }) => resolveColor("common.border", theme)} solid 1px;
        border-right: ${({ theme }) => resolveColor("common.border", theme)} solid 1px;
        padding: 0.8rem 0.3rem;
        &:nth-child(even) {
            background-color: ${getColor("common.accent")};
        }
    `,
};
productCarouselStyles.attributeLabelsCellGridItem = {
    width: [4, 4, 4, 2, 2],
    css: css`
        padding-top: 20px;
        > div {
            border-left: 1px solid #ccc;
            border-top: 1px solid #ccc;
        }
    `,
};
productCarouselStyles.attributeValuesCellGridItem = {
    width: [8, 8, 8, 10, 10],
    css: css`
        padding-top: 20px;
        > div {
            border-right: 1px solid #ccc;
            border-top: 1px solid #ccc;
        }
    `,
};

productCarouselStyles.prevArrowGridItem = {
    width: 1,
    align: "top",
    css: css`
        justify-content: flex-start;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
            ])}
    `,
};

productCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        transform: translateY(180px);
        cursor: pointer;
        font-family: inherit;
        height: 40px;
        line-height: 1;
        backface-visibility: hidden;
        transition: all 200ms ease-in-out 0s;
        color: #474747;
        border: 0;
        padding: 5px;
        background: #f8f8f8;
        z-index: 1;

        &:hover {
            background: #ef3742;
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};

productCarouselStyles.nextArrowGridItem = {
    width: 1,
    align: "top",
    css: css`
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
                css`
                    flex-basis: 5%;
                    max-width: 5%;
                `,
            ])}
    `,
};

productCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        transform: translateY(180px);
        cursor: pointer;
        font-family: inherit;
        height: 40px;
        line-height: 1;
        backface-visibility: hidden;
        transition: all 200ms ease-in-out 0s;
        color: #474747;
        border: 0;
        padding: 5px;
        background: #f8f8f8;
        z-index: 1;

        &:hover {
            background: #ef3742;
            opacity: 0.8;
            span {
                color: #fff !important;
            }
        }
    `,
};

productCarouselProductFullStyles.descriptionGridItem = {
    width: 12,
    css: css`
        padding: 5px 15px 5px 15px;
    `,
};
productCarouselProductFullStyles.partNumberGridItem = {
    width: 12,
    css: css`
        padding: 5px 0 5px 0;
        > div {
            width: 100%;
            border-top: 1px dotted green;
            border-bottom: 1px dotted green;
            display: flex;
        }
    `,
};
